var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property, unsafeHTML } from '@inter-ikea-kompis/web-component';
import { SafariWriteDirectionUtility } from '@inter-ikea-kompis/utilities';
import IconSizeCalculator from '../../utilities/IconSizeCalculator.js';
// The base size UX uses when designing icons
const BASE_SIZE = 24;
/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 *
 * Icon component.
 */
export default class Icon extends KompisElement {
    constructor() {
        super(...arguments);
        // Flip the icon horizontally in RTL context
        this.flipIconRtl = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        if (!this.icon) {
            return null;
        }
        const { width, height } = IconSizeCalculator.getMeasuredSize(this.icon, BASE_SIZE);
        const direction = SafariWriteDirectionUtility.getWriteDirection(this);
        return html `
			<style>
				:host {
					display: inline-flex;
					justify-content: center;
					align-items: center;
				}
				svg {
					overflow: visible;
					width: ${IconSizeCalculator.round(width / 16)}rem;
					height: ${IconSizeCalculator.round(height / 16)}rem;
				}

				${this.flipIconRtl ? this.getFlipIconRtlStyle(direction) : null}
			</style>
			${unsafeHTML(this.icon.replace('<svg', '<svg aria-hidden="true"'))}
		`;
    }
    /**
     * Style for flip icon.
     *
     * @param direction Direction.
     * @returns Style for kiosk.
     */
    getFlipIconRtlStyle(direction) {
        if (direction === 'rtl') {
            return `
				:host {
					transform: scaleX(-1);
				}
				:host-context {
					transform: scaleX(-1);
				}
			`;
        }
        return `
			:host(:dir(rtl)) {
				transform: scaleX(-1);
			}
			:host-context([dir='rtl']) {
				transform: scaleX(-1);
			}
		`;
    }
}
__decorate([
    property({ type: String, required: true })
], Icon.prototype, "icon", void 0);
__decorate([
    property({ type: Object, required: true })
], Icon.prototype, "theme", void 0);
__decorate([
    property({ type: Boolean })
], Icon.prototype, "flipIconRtl", void 0);
//# sourceMappingURL=Icon.js.map